import * as React from 'react';

import Form from '../../components/FormGenerator/Form';
import { userDataFields } from '../../formFields';
import { Button, Section, Title, Loader } from '../../modules/modules';
import { MutationFunc } from 'react-apollo';
import FlashStore from '../../services/FlashStore';
import UserWrap from '../../components/UserWrap';
import AuthService from '../../services/AuthService';
import CountryService from '../../services/CountryService';
import { RouteComponentProps } from 'react-router-dom';
import CartService from '../../services/CartService';
import RequestCompanyChangeModal from '../../components/CustomerData/RequestChangeModal';

interface IUserDataProps extends RouteComponentProps<{ language: string }> {
  formPlaceholders?: any;
  data: any;
  countries: any;
  updateUserInfo: MutationFunc;
  requestCompanyChange: MutationFunc;
}

interface IUserDataState {
  formFields: any[];
  formValues: any;
  loaded: boolean;
  requestFormOpened: boolean;
}
class UserData extends React.Component<IUserDataProps, IUserDataState> {
  public static getDerivedStateFromProps(props: IUserDataProps, state: IUserDataState) {
    if (props.data.userInfo != undefined && !state.loaded) {
      const userInfo = props.data.userInfo as GQL.IUser;
      return {
        ...state,
        loaded: true,
        formValues: {
          ...state.formValues,
          Firstname: userInfo.invoiceFirstName,
          Lastname: userInfo.invoiceLastName,
          Email: userInfo.email,
          Phone: userInfo.phone,

          AddressStreet: userInfo.invoiceStreet,
          AddressStreetNumber: userInfo.invoiceHouseNumber,
          AddressLine1: userInfo.invoiceAddressLine1,
          AddressLine2: userInfo.invoiceAddressLine2,
          AddressZip: userInfo.invoiceZip,
          AddressCity: userInfo.invoiceCity,
          AddressCountyState: userInfo.invoiceCountyState,
          AddressCountry: userInfo.invoiceCountry,

          AnotherDeliveryAddress: userInfo.anotherDeliveryAddress,
          DeliveryAddressPhone: userInfo.deliveryPhone,
          DeliveryAddressStreet: userInfo.deliveryStreet,
          DeliveryAddressStreetNumber: userInfo.deliveryHouseNumber,
          DeliveryAddressLine1: userInfo.deliveryAddressLine1,
          DeliveryAddressLine2: userInfo.deliveryAddressLine2,
          DeliveryAddressZip: userInfo.deliveryZip,
          DeliveryAddressCity: userInfo.deliveryCity,
          DeliveryAddressCountyState: userInfo.deliveryCountyState,
          DeliveryAddressCountry: userInfo.deliveryCountry,

          Newsletter: userInfo.receiveNewsletter,

          CompanyInformation: userInfo.companyInformation,
          Company: userInfo.companyName,
          CompanyRegistrationNumber: userInfo.companyRegistrationNumber,
          CompanyVatNumber: userInfo.companyVatNumber,
          CompanyVatValidationDate: userInfo.companyVatValidationDate
        },
      };
    }

    return state;
  }

  constructor(props: IUserDataProps) {
    super(props);

    this.state = {
      formFields: [...userDataFields],
      formValues: {},
      requestFormOpened: false,
      loaded: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  public toggleRequestForm = () => {
    this.setState({ requestFormOpened: !this.state.requestFormOpened });
  }

  public getField(fields: any[], name: string) {
    const key = fields.findIndex((i: any) => i.fieldName === name);
    return fields[key];
  }

  public handleChange(value: any, field: string) {
    this.setState({ formValues: { ...this.state.formValues, [field]: value } });
  }

  public setFormState(fields: any) {
    this.setState({
      formFields: fields
    });
  }

  public async handleSend(form: any) {
    const isValid = await form.validate((fields: any) => {
      this.setFormState(fields);
    });

    const {
      countries: { countries },
      history: { push, location: { search } }
    } = this.props;

    if (!isValid) {
      FlashStore.GetInstance().showMessage('If you want use your profile, fill required information please!', 'error');
      return;
    }

    const searchQuery = new URLSearchParams(search);
    const returnTo = searchQuery.get('returnTo');

    const {
      Firstname,
      Lastname,
      Phone,
      AddressStreet,
      AddressStreetNumber,
      AddressLine1,
      AddressLine2,
      AddressZip,
      AddressCity,
      AddressCountyState,
      AddressCountry,

      AnotherDeliveryAddress,
      DeliveryAddressPhone,
      DeliveryAddressStreet,
      DeliveryAddressStreetNumber,
      DeliveryAddressLine1,
      DeliveryAddressLine2,
      DeliveryAddressZip,
      DeliveryAddressCity,
      DeliveryAddressCountyState,
      DeliveryAddressCountry,

      Newsletter,
      CompanyInformation,
      Company,
      CompanyRegistrationNumber,
      CompanyVatNumber
    } = this.state.formValues;

    try {
      const user = {
        phone: Phone,

        invoiceFirstName: Firstname,
        invoiceLastName: Lastname,
        invoiceStreet: AddressStreet,
        invoiceHouseNumber: AddressStreetNumber,
        invoiceAddressLine1: AddressLine1,
        invoiceAddressLine2: AddressLine2 || null,
        invoiceZip: AddressZip,
        invoiceCity: AddressCity,
        invoiceCountyState: AddressCountyState || null,
        invoiceCountry: AddressCountry,

        anotherDeliveryAddress: AnotherDeliveryAddress,
        deliveryPhone: AnotherDeliveryAddress ? DeliveryAddressPhone : null,
        deliveryStreet: AnotherDeliveryAddress ? DeliveryAddressStreet : null,
        deliveryHouseNumber: AnotherDeliveryAddress ? DeliveryAddressStreetNumber : null,
        deliveryAddressLine1: AnotherDeliveryAddress ? DeliveryAddressLine1 : null,
        deliveryAddressLine2: AnotherDeliveryAddress ? DeliveryAddressLine2 || null : null,
        deliveryZip: AnotherDeliveryAddress ? DeliveryAddressZip : null,
        deliveryCity: AnotherDeliveryAddress ? DeliveryAddressCity : null,
        deliveryCountyState: AnotherDeliveryAddress ? DeliveryAddressCountyState || null : null,
        deliveryCountry: AnotherDeliveryAddress ? DeliveryAddressCountry : null,

        receiveNewsletter: Newsletter || false,

        companyInformation: CompanyInformation,
        companyName: CompanyInformation ? Company : null,
        companyRegistrationNumber: CompanyInformation ? CompanyRegistrationNumber : null,
        companyVatNumber: CompanyInformation ? CompanyVatNumber : null,
      };

      // update customer with current data
      const authService = AuthService.GetInstance();
      authService.setCustomer({ ...authService.customer, ...user as GQL.IUser });

      await this.props.updateUserInfo({
        variables: {
          user
        }
      });

      await this.props.data.refetch();
      
      // update cart as well
      CartService.GetInstance().setCustomerData(this.state.formValues);

      if (Array.isArray(countries)) {
        const currentCountry = CountryService.GetInstance().country;
        const targetCountryName = AnotherDeliveryAddress ? DeliveryAddressCountry || AddressCountry : AddressCountry;
      const targetCountry = countries.find((country: GQL.ICountry) => country.name === targetCountryName);
        // return to original location after save
        if (returnTo) {
          push(returnTo.replace(`/${currentCountry.code}/`, `/${targetCountry.code}/`));
        } else {
          if (currentCountry.code !== targetCountry.code) {
            // Country code urls are not used anymore
            // push(`/${targetCountry.code}/user/data`);
            CountryService.GetInstance().setCountry(targetCountry, true);
          }
        }
      }

      FlashStore.GetInstance().showMessage('Personal data successfully updated', 'success');
    } catch (e) {
      // TODO

    }
  }

  public render() {
    const { requestFormOpened } = this.state;
    const { CompanyVatNumber } = this.state.formValues;
    return (
      <main>
        <Section type="userPage">
          <UserWrap>

            {this.props.data.loading &&
              <Loader />}

            <div className="boundaries">
              <Title type="lower">Personal data</Title>

              {CompanyVatNumber && <p className="companyDetailsMessage">
                Company name, VAT ID, and country are locked after validation.<br />
                If you need to change any of these details, please&nbsp;
                <a href="javascript:void(0)" onClick={this.toggleRequestForm} style={{ color: 'red', textDecoration: 'underline' }}>contact our customer support</a>.
              </p>}

              <div className="form form--userData">
                <Form
                  fields={this.state.formFields}
                  values={this.state.formValues}
                  handleChange={this.handleChange}
                >
                  {(form: any) => {
                    return (
                      <Button
                        type="text"
                        onClick={() => {
                          this.handleSend(form);
                        }}
                      >
                        Save changes
                      </Button>
                    );
                  }}
                </Form>
                
              </div>
            </div>
          </UserWrap>
        </Section>
        {requestFormOpened && <RequestCompanyChangeModal
          customer={this.state.formValues}
          requestCompanyChange={this.props.requestCompanyChange}
          toggleRequestForm={this.toggleRequestForm}
        />}
      </main >
    );
  }
}

export default UserData;



// WEBPACK FOOTER //
// ./src/pages/UserData/UserData.tsx